import { Field, TextAreaEditor, TextEditor } from '@approvalmax/ui';
import { constants } from 'modules/common';
import { memo } from 'react';

import { Row, RowGroup } from '../../XeroCreateContactPopup.styles';
import { messages } from './AddressSection.messages';
import { AddressFields, AddressFieldsRow } from './AddressSection.styles';
import { AddressSectionProps } from './AddressSection.types';

const { xeroConstants } = constants;

export const AddressSection = memo<AddressSectionProps>((props) => {
    const { address, name, qa, onChange } = props;

    return (
        <RowGroup>
            <Row>
                <Field title={messages.addressAttentionLabel}>
                    <TextEditor
                        qa={qa(`${name}-attention-to-editor`)}
                        value={address.attentionTo || ''}
                        maxLength={xeroConstants.ADDRESS_ATTENTION_TO_MAX_LENGTH}
                        onChange={onChange(name, 'attentionTo')}
                        placeholder={messages.addressAttentionPlaceholder}
                    />
                </Field>

                <Field title={messages.cityLabel}>
                    <TextEditor
                        qa={qa(`${name}-city-editor`)}
                        value={address.city || ''}
                        maxLength={xeroConstants.ADDRESS_CITY_MAX_LENGTH}
                        onChange={onChange(name, 'city')}
                        placeholder={messages.addressCityPlaceholder}
                    />
                </Field>
            </Row>

            <Row>
                <Field title={messages.addressLabel}>
                    <TextAreaEditor
                        qa={qa(`${name}-address-editor`)}
                        value={address.address || ''}
                        maxLength={xeroConstants.ADDRESS_MAX_LENGTH}
                        onChange={onChange(name, 'address')}
                        placeholder={messages.addressPlaceholder}
                        minHeight={4}
                        maxHeight={8}
                    />
                </Field>

                <AddressFields>
                    <AddressFieldsRow>
                        <Field title={messages.stateLabel}>
                            <TextEditor
                                qa={qa(`${name}-region-editor`)}
                                value={address.region || ''}
                                maxLength={xeroConstants.ADDRESS_REGION_MAX_LENGTH}
                                onChange={onChange(name, 'region')}
                                placeholder={messages.addressRegionPlaceholder}
                            />
                        </Field>

                        <Field title={messages.postalCodeLabel}>
                            <TextEditor
                                qa={qa(`${name}-postal-code-editor`)}
                                value={address.postalCode || ''}
                                maxLength={xeroConstants.ADDRESS_POST_CODE_MAX_LENGTH}
                                onChange={onChange(name, 'postalCode')}
                                placeholder={messages.addressPostalCodePlaceholder}
                            />
                        </Field>
                    </AddressFieldsRow>

                    <Field title={messages.countryLabel}>
                        <TextEditor
                            qa={qa(`${name}-country-editor`)}
                            value={address.country || ''}
                            maxLength={xeroConstants.ADDRESS_COUNTRY_MAX_LENGTH}
                            onChange={onChange(name, 'country')}
                            placeholder={messages.addressCountryPlaceholder}
                        />
                    </Field>
                </AddressFields>
            </Row>
        </RowGroup>
    );
});
